controllers.controller('WalletController', [
    '$window', '$scope', '$state', '$ionicLoading', 'LocaleService', 'UserService', 'constants', 'UserControl',
    'config', 'Storage', '$timeout', 'API', 'Onesignal',
    function ($window, $scope, $state, $ionicLoading, LocaleService, UserService, Const, UserControl,
              Config, Storage, $timeout, API, Onesignal) {

        $ionicLoading.hide();

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.config = Config;

        $scope.paymentMethods = Storage.get('paymentMethods') || [];

        $scope.openDepositPage = function (method) {
            // TODO - will be placed in every payment method controller
            updateDepositTag();
            switch (method.type) {
                case 'module':
                    return method.hosted ?
                        $scope.navigate('root.app.hostedpage', {method: method}) :
                        $scope.navigate('root.app.' + method.name, {method: method});
                case 'modulepopup':
                    return method.hosted ?
                        $scope.navigate('root.app.hostedpage-popup', {method: method}) :
                        $scope.navigate('root.app.' + method.name, {method: method});
                case 'modulewindow':
                    return $scope.navigate('root.app.hostedpage-window', {method: method});
                case 'qrcode':
                    return $scope.navigate('root.app.qrcode', {method: method});
                case 'pendingDeposit':
                    return $scope.navigate('root.app.pendingdeposit', {method: method});
                case 'link':
                    $window.open(method.url, '_blank', 'hardwareback=no,location=0,menubar=0,closebuttoncaption=Back,hidden=yes');
                    return;
                case 'iframe':
                    return method.url.length > 0 ?
                        $scope.navigate('root.app.external', {method: method}) :
                        $scope.navigate('root.app.' + method.name, {method: method});

            }
        };

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            $scope.state = UserControl.getState();

            if (user && user.liveAccountExists) {
                if ($scope.paymentMethods.length === 0) {
                    $scope.modal.textTitle = LocaleService.translation.paymentDetails;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = LocaleService.translation.emptyPspMessage;
                    $scope.modal.back = 'root.app.assets';
                    $timeout(function () {
                        $scope.modal.state = true;
                    }, 0)
                }
                return;
            }

            // follow cmtrading registration flow
            /*if ($scope.state && !Const['splitPersonalDetails']) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.state && Const['splitPersonalDetails'] && user.registrationState < 3) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.paymentMethods.length === 0) {
                $scope.modal.textTitle = LocaleService.translation.paymentDetails;
                $scope.modal.actionText = LocaleService.translation.close;
                $scope.modal.isError = false;
                $scope.modal.textContent = LocaleService.translation.emptyPspMessage;
                $scope.modal.back = 'root.app.assets';
                $timeout(function () {
                    $scope.modal.state = true;
                }, 0)
            }


            if (user) {
                if (user.activeTradingAccount && !user.activeTradingAccount.live) {
                    $scope.modal.textTitle = LocaleService.translation.depositDemoTitle;
                    $scope.modal.actionText = LocaleService.translation.switchAccountButton;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.depositDemoContent;
                    $scope.modal.back = 'root.app.manageAccounts';
                    $timeout(function () {
                        $scope.modal.state = true;
                    }, 0);
                    return;
                }
                if (user.activeTradingAccount && user.activeTradingAccount.live && user.depositValidationRequired) {
                    $scope.modal.textTitle = LocaleService.translation.depositUnavailableTitle;
                    $scope.modal.actionText = LocaleService.translation.continue;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.depositUnavailableContent;
                    $scope.modal.back = $scope.sendTicket;
                    $timeout(function () {
                        $scope.modal.state = true;
                    }, 0);
                    return;
                }
            }*/

            if ($scope.paymentMethods.length === 1 && user.activeTradingAccount && user.activeTradingAccount.live) {
                $scope.openDepositPage($scope.paymentMethods[0]);
            }

            return $state.go($scope.state, {cache: false});
        });

        $scope.sendTicket = function () {
            var request = {
                type: 'Deposit or Withdrawal',
                subject: 'Unvalidated client Attempted to make a deposit',
                description: 'Unvalidated client has tried to perform a deposit however was rejected due to its validation status.'
                    + 'Validation status can be adjusted from the client detailed view page using the CRM action buttons.'
            };

            return API.createTicket(request)
                .then(function () {
                    return $state.go('root.app.assets');
                })

        };

        $scope.walletNav = function (method) {
            if (method.name === 'wiretransfer' && method.type === 'link') {
                window.open(method.url, '_blank', 'hardwareback=no,location=0,menubar=0,closebuttoncaption=Back,hidden=yes');
                return false;
            } else {
                $state.go('root.app.' + method.name);
            }
        };

        function clear() {
        }

        function updateDepositTag() {
            Onesignal.getTags()
                .then(function (tags) {
                    if (!tags) {
                        return;
                    }
                    if (tags.hasOwnProperty('deposit')) {
                        Onesignal.setTag('deposit', Number(tags.deposit) + 1)
                    } else {
                        Onesignal.setTag('deposit', 1)
                    }
                })
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('$ionicView.unloaded', clear);
        $scope.$on('clear', clear);

    }]);
